export interface SocketServerDto {
  action: SocketAction
  options?: SocketOptions
}

export interface SocketClientDto {
  ts: Date
  level: string
  message: string
}

export enum SocketAction {
  LOG_START = 'LOG_START',
  LOG_STOP = 'LOG_STOP',
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SocketOptions {}

export interface LogStartOptions extends SocketOptions {
  endAt: Date
  withReplay: boolean
}
